module.exports = __webpack_public_path__ + "static/img/fr.b1156355.svg";